//@ts-check
import formulas from '../../formulas';
import fieldsHelper from '../../utils/fieldsHelper';
import repeatingLogic from '../repeatingLogic';
/**
 * @param {import("../types").EcrionFormState} state
 * @param {string} fieldId
 * @param {any} value
 * @param {boolean} updateDependentsFields
 */

var changeFieldValue = function changeFieldValue(state, fieldId, value) {
  var updateDependentsFields = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var oldFieldValue = state.data[fieldId];
  if (oldFieldValue === null && (value === null || value === undefined)) return;
  if (oldFieldValue === undefined && (value === null || value === undefined)) return;
  if (oldFieldValue === value) return;
  setMetaProp(state, fieldId, 'error', '');
  state.data[fieldId] = value;
  calculateDependentProps(state, fieldId, updateDependentsFields);
  state.meta['FORM'].dirty = true; // form is now dirty
};
/**
 * @param {import("../types").EcrionFormState} state
 * @param {string} fieldId
 * @param {any} value
 */


var changeRepeatingFieldValue = function changeRepeatingFieldValue(state, fieldId, value) {
  var field = state.fields[fieldId];
  var oldFieldValue = state.data[fieldId];
  if (oldFieldValue === null && (value === null || value === undefined)) return;
  if (oldFieldValue === undefined && (value === null || value === undefined)) return;
  if (oldFieldValue === value) return;
  setMetaProp(state, fieldId, 'error', '');
  preProcessValueChanged(state, field, oldFieldValue, value);
  state.data[fieldId] = value;
  state.meta['FORM'].dirty = true; // form is now dirty
};
/**
 * @param {import("../types").EcrionFormState} state
 * @param {string} fieldId
 * @param {boolean} updateDependentsFields
 */


var calculateDependentProps = function calculateDependentProps(state, fieldId, updateDependentsFields) {
  var fields = Object.keys(state.fields).map(function (id) {
    return state.fields[id];
  });
  var field = state.fields[fieldId];
  if (!field) debugger;
  var fieldsIds = state.dependencies[field.originalId || field.id];
  if (!fieldsIds) return;
  fieldsIds.forEach(function (id) {
    var clonedFields = fields.filter(function (f) {
      return f.originalId === id;
    }) || [];
    if (clonedFields.length === 0) clonedFields.push(state.fields[id]);
    clonedFields.forEach(function (f) {
      var properties = getPropertiesDependentOnField(f, fieldId, state);
      if (!properties || !properties.length) return;
      properties.forEach(function (property) {
        updateFieldProperty(state, f.id, property.name, property.value);
        if (updateDependentsFields) postProcessFieldPropertyChanged(state, f, property.name);
      });
    });
  });
};
/**
 * @param {import('../types').EcrionFormState} state
 * @param {string} fieldId
 * @param {string} name
 * @param {string} value
 */


var updateFieldProperty = function updateFieldProperty(state, fieldId, name, value) {
  var newValue = formulas.calculate(value, state.fields[fieldId], state);

  switch (name) {
    case 'defaultValue':
      state.data[fieldId] = newValue;
      break;

    case 'maxItems':
      updateMaxItemsProperty(newValue, state, fieldId);
      break;

    case 'minItems':
      updateMinItemsProperty(newValue, state, fieldId);
      break;

    case 'min':
    case 'max':
      updateNumericProperty(name, newValue, state, fieldId);
      break;

    case 'submitTmpl':
      setMetaProp(state, fieldId, name, newValue);

    default:
      // add new properties here if you want to support dynamic values for that properties
      break;
  }
};
/**
 * @param {import('../types').EcrionFormState} state
 * @param {import('../types').EcrionFormField} field
 * @param {string} name
 */


var postProcessFieldPropertyChanged = function postProcessFieldPropertyChanged(state, field, name) {
  if (field.type !== 'repeating') return;
  var values = (state.data[field.id] || [0]).map(function (f) {
    return f;
  });
  var currentLength = values.length;

  if (name === 'minItems') {
    var minItems = state.meta[field.id][name] || 1;

    if (minItems > currentLength) {
      var lastValue = values[currentLength - 1];

      for (var idx = 0; idx < minItems - currentLength; idx++) {
        values.push(lastValue + idx + 1);
      }

      repeatingLogic.updateValues(state, field, state.data[field.id], values);
      state.data[field.id] = values;
    }
  }

  if (name === 'maxItems') {
    var maxItems = state.meta[field.id][name] || 1;

    if (maxItems > 0 && maxItems < currentLength) {
      values.splice(maxItems);
      repeatingLogic.updateValues(state, field, state.data[field.id], values);
      state.data[field.id] = values;
    }
  }
};
/**
 * @param {string} name
 * @param {string} value
 * @param {import('../types').EcrionFormState} state
 * @param {string} fieldId
 */


var updateNumericProperty = function updateNumericProperty(name, value, state, fieldId) {
  var numericValue = parseFloat(value);
  if (isNaN(numericValue)) return;
  setMetaProp(state, fieldId, name, numericValue);
};
/**
 * @param {string} value
 * @param {import('../types').EcrionFormState} state
 * @param {string} fieldId
 */


var updateMaxItemsProperty = function updateMaxItemsProperty(value, state, fieldId) {
  var maxItemsValue = parseInt(value);
  if (isNaN(maxItemsValue)) return;
  var field = state.fields[fieldId];
  if (!field || field.type !== 'repeating') return;
  setMetaProp(state, fieldId, 'maxItems', maxItemsValue);
};
/**
 * @param {string} value
 * @param {import('../types').EcrionFormState} state
 * @param {string} fieldId
 */


var updateMinItemsProperty = function updateMinItemsProperty(value, state, fieldId) {
  var minItemsValue = parseInt(value);
  if (isNaN(minItemsValue)) return;
  var field = state.fields[fieldId];
  if (!field || field.type !== 'repeating') return;
  setMetaProp(state, fieldId, 'minItems', minItemsValue);
};
/**
 * @param {import('../types').EcrionFormState} state
 * @param {import('../types').EcrionFormField} field
 * @param {any} oldValue
 * @param {any} newValue
 */


var preProcessValueChanged = function preProcessValueChanged(state, field, oldValue, newValue) {
  switch (field.type) {
    case 'repeating':
      repeatingLogic.updateValues(state, field, oldValue, newValue);
      break;
  }
};
/**
 * @param {import('../types').EcrionFormState} state
 * @param {string} fieldId
 * @param {string} name
 * @param {any} value
 */


var setMetaProp = function setMetaProp(state, fieldId, name, value) {
  if (!state) return;
  if (!state.meta) state.meta = {};
  if (!state.meta[fieldId]) state.meta[fieldId] = {};
  state.meta[fieldId][name] = value;
};
/**
 * @param {string} value
 * @param {import('../types').EcrionFormField} field
 * @param {import('../types').EcrionFormState} state
 */


var valueDependsOnField = function valueDependsOnField(value, field, state) {
  var dependencies = formulas.parseDependencies(value, state);
  if (!dependencies) return false;
  var fieldId = field.originalId || field.id; // we need to compare also with original id in case of cloned field

  return dependencies.find(function (d) {
    return d.id === fieldId && d.type === 'field';
  });
};
/**
 * Get all properties from a specified field that are dependent on another field
 * @param {import('../types').EcrionFormField} field
 * @param {string} fieldId The field id on which the properties depend
 * @param {import('../types').EcrionFormState} state
 * @return {Array<{name:string, value:string}>}
 */


var getPropertiesDependentOnField = function getPropertiesDependentOnField(field, fieldId, state) {
  if (!fieldsHelper.hasCommonRepeatingContext(state, field, state.fields[fieldId])) return []; // get all properties from the field

  var properties = Object.keys(field).map(function (propName) {
    return {
      name: propName,
      value: field[propName]
    };
  });
  return properties.filter(function (property) {
    // only properties with string value can depend on other fields
    if (typeof property.value !== 'string') return false;
    return valueDependsOnField(property.value, state.fields[fieldId], state);
  });
};

export default {
  changeFieldValue: changeFieldValue,
  changeRepeatingFieldValue: changeRepeatingFieldValue,
  updateFieldProperty: updateFieldProperty
};